<template>
    <div>
        <!-- Slot Search -->
        <div class="mb-1 ml-2 mr-2">
            <slot></slot>
        </div>
        <!--  -->
        <div v-if="loadingApp == false">
            <div v-if="data.data.length > 0">
                <div v-for="(dataItem, date) in groupByDate" :key="date">
                    <!-- item -->
                    <div
                        class="listview-title"
                        style="
                            background-color: #f3f4f5;
                            padding: 2px 16px;
                            font-weight: normal;
                        "
                    >
                        {{ date }}
                    </div>
                    <ul class="listview image-listview-product full ml-0 mr-0">
                        <li v-for="item in dataItem" :key="item.id">
                            <!-- PRABAYAR -->
                            <router-link
                                :to="{
                                    name: 'transaction.prabayar.show',
                                    params: { id: item.transaction_details.id },
                                }"
                                class="item pl-2 pr-3 pt-2 pb-2"
                                v-if="item.type == 'PRABAYAR'"
                            >
                                <div class="imageWrapper mr-1">
                                    <img
                                        v-if="
                                            item.transaction_details.category !=
                                            null
                                        "
                                        v-lazyload
                                        :src="require('@/assets/Loader-2.png')"
                                        :data-src="
                                            VUE_ENV.VUE_APP_ASSET_URL +
                                            '/img/icon/' +
                                            item.transaction_details.category
                                                .icon
                                        "
                                        alt="image"
                                        class="imaged w36"
                                    />
                                    <img
                                        v-else
                                        v-lazyload
                                        :src="require('@/assets/Loader-2.png')"
                                        :data-src="
                                            require('@/assets/other.png')
                                        "
                                        alt="image"
                                        class="imaged w36"
                                    />
                                </div>
                                <div class="in">
                                    <div style="width: 90%">
                                        <header>
                                            {{
                                                item.transaction_details
                                                    .category_name
                                            }}
                                            •
                                            {{
                                                item.transaction_details
                                                    .operator_name
                                            }}
                                        </header>
                                        <h4>
                                            {{
                                                item.transaction_details
                                                    .product_name
                                            }}
                                        </h4>
                                        <footer>
                                            {{
                                                item.transaction_details
                                                    .destination
                                            }}
                                        </footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <!-- <small>ID#{{ item.id }}</small> -->
                                        <h5
                                            class="mb-0"
                                            style="font-weight: normal"
                                        >
                                            Rp
                                            {{
                                                item.transaction_details.price
                                                    | rupiah
                                            }}
                                        </h5>
                                        <strong
                                            class="text-success"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'SUCCESS'
                                            "
                                            >Berhasil</strong
                                        >
                                        <strong
                                            class="text-warning"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'PENDING' ||
                                                item.transaction_details
                                                    .status == 'ONPROCESS'
                                            "
                                            >Dalam proses</strong
                                        >
                                        <strong
                                            class="text-info"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'HOLDON'
                                            "
                                            >Dalam pengecekan</strong
                                        >
                                        <strong
                                            class="text-danger"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'FAILED'
                                            "
                                            >Gagal</strong
                                        >
                                    </span>
                                </div>
                            </router-link>
                            <!-- PASCABAYAR -->
                            <router-link
                                :to="{
                                    name: 'transaction.pascabayar.show',
                                    params: { id: item.transaction_details.id },
                                }"
                                class="item pl-2 pr-3 pt-2 pb-2"
                                v-else-if="item.type == 'PASCABAYAR'"
                            >
                                <div class="imageWrapper mr-1">
                                    <img
                                        v-if="
                                            item.transaction_details.category !=
                                            null
                                        "
                                        v-lazyload
                                        :src="require('@/assets/Loader-2.png')"
                                        :data-src="
                                            VUE_ENV.VUE_APP_ASSET_URL +
                                            '/img/icon/' +
                                            item.transaction_details.category
                                                .icon
                                        "
                                        alt="image"
                                        class="imaged w36"
                                    />
                                    <img
                                        v-else
                                        v-lazyload
                                        :src="require('@/assets/Loader-2.png')"
                                        :data-src="
                                            require('@/assets/other.png')
                                        "
                                        alt="image"
                                        class="imaged w36"
                                    />
                                </div>
                                <div class="in">
                                    <div style="width: 90%">
                                        <header>
                                            {{
                                                item.transaction_details
                                                    .category_name
                                            }}
                                        </header>
                                        <h4>
                                            {{
                                                item.transaction_details
                                                    .product_name
                                            }}
                                        </h4>
                                        <footer>
                                            {{
                                                item.transaction_details
                                                    .no_pelanggan
                                            }}
                                        </footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <!-- <small>ID#{{ item.id }}</small> -->
                                        <h5
                                            class="mb-0"
                                            style="font-weight: normal"
                                        >
                                            Rp
                                            {{
                                                item.transaction_details
                                                    .bill_total_bayar | rupiah
                                            }}
                                        </h5>
                                        <strong
                                            class="text-success"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'PAID'
                                            "
                                            >Berhasil</strong
                                        >
                                        <strong
                                            class="text-warning"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'PENDING'
                                            "
                                            >Dalam proses</strong
                                        >
                                        <strong
                                            class="text-info"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'HOLDON'
                                            "
                                            >Dalam pengecekan</strong
                                        >
                                        <strong
                                            class="text-danger"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'FAILED'
                                            "
                                            >Gagal</strong
                                        >
                                    </span>
                                </div>
                            </router-link>
                            <!-- KIRIM UANG -->
                            <router-link
                                :to="{
                                    name: 'transaction.sendmoney.show',
                                    params: { id: item.transaction_details.id },
                                }"
                                class="item pl-2 pr-3 pt-2 pb-2"
                                v-else-if="item.type == 'SENDMONEY'"
                            >
                                <div class="imageWrapper mr-1">
                                    <img
                                        v-lazyload
                                        :src="require('@/assets/Loader-2.png')"
                                        :data-src="
                                            require('@/assets/icon_menu/transfer_rekening.png')
                                        "
                                        alt="image"
                                        class="imaged w36"
                                    />
                                </div>
                                <div class="in">
                                    <div style="width: 90%">
                                        <header>
                                            {{
                                                item.transaction_details
                                                    .category_name
                                            }}
                                            •
                                            <span
                                                v-if="
                                                    item.transaction_details
                                                        .transfer_method ==
                                                    'TRANSFER_ONLINE'
                                                "
                                                >Transfer Online</span
                                            >
                                            <span
                                                v-else-if="
                                                    item.transaction_details
                                                        .transfer_method ==
                                                    'BI_FAST'
                                                "
                                                >BI Fast</span
                                            >
                                        </header>
                                        <h4>
                                            {{
                                                item.transaction_details
                                                    .product_name
                                            }}
                                        </h4>
                                        <footer>
                                            {{
                                                item.transaction_details
                                                    .no_rekening
                                            }}
                                        </footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <!-- <small>ID#{{ item.id }}</small> -->
                                        <h5
                                            class="mb-0"
                                            style="font-weight: normal"
                                        >
                                            Rp
                                            {{
                                                item.transaction_details.total
                                                    | rupiah
                                            }}
                                        </h5>
                                        <strong
                                            class="text-success"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'SUCCESS'
                                            "
                                            >Berhasil</strong
                                        >
                                        <strong
                                            class="text-warning"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'PENDING'
                                            "
                                            >Dalam proses</strong
                                        >
                                        <strong
                                            class="text-info"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'HOLDON'
                                            "
                                            >Dalam pengecekan</strong
                                        >
                                        <strong
                                            class="text-danger"
                                            style="font-weight: bold"
                                            v-if="
                                                item.transaction_details
                                                    .status == 'FAILED'
                                            "
                                            >Gagal</strong
                                        >
                                    </span>
                                </div>
                            </router-link>
                            <!-- TRANSFER KE SESAMA -->
                            <router-link
                                :to="{
                                    name: 'transaction.transfer.show',
                                    params: { id: item.transaction_details.id },
                                }"
                                class="item pl-2 pr-3 pt-2 pb-2"
                                v-else-if="item.type == 'TRANSFER'"
                            >
                                <div class="imageWrapper mr-1">
                                    <img
                                        v-lazyload
                                        :src="require('@/assets/Loader-2.png')"
                                        :data-src="
                                            require('@/assets/icon_menu/transfer_sesama.png')
                                        "
                                        alt="image"
                                        class="imaged w36"
                                    />
                                </div>
                                <div class="in">
                                    <div style="width: 90%">
                                        <header>Transfer ke Sesama</header>
                                        <h4>
                                            Transfer Saldo
                                            {{
                                                item.transaction_details.nominal
                                                    | rupiah
                                            }}
                                        </h4>
                                        <footer>
                                            {{
                                                item.transaction_details
                                                    .to_customer.phone
                                            }}
                                        </footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <!-- <small>ID#{{ item.id }}</small> -->
                                        <h5
                                            class="mb-0"
                                            style="font-weight: normal"
                                        >
                                            Rp
                                            {{
                                                item.transaction_details.nominal
                                                    | rupiah
                                            }}
                                        </h5>
                                        <strong
                                            class="text-success"
                                            style="font-weight: bold"
                                            >Berhasil</strong
                                        >
                                    </span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                    <!-- * item -->
                </div>
                <div
                    class="m-2 text-center"
                    v-if="data.next_page_url && data.to >= data.per_page"
                >
                    <ButtonLoader
                        :loading="loadingButton"
                        :styled="'btn btn-primary rounded mr-1 mb-1'"
                        @click.native="$emit('paginate')"
                        >Lihat lebih banyak</ButtonLoader
                    >
                </div>
            </div>
            <div class="text-center mt-5 mb-5" v-else>
                <img
                    :src="require('@/assets/image/empty.webp')"
                    alt="404"
                    class="w-75 mb-3"
                /><br />
                <h2 class="mb-0">Belum Ada Data</h2>
                <p>Tidak ada data yang dapat ditampilkan</p>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import moment from 'moment';
    moment.locale('id');
    export default {
        props: ['data', 'loadingButton', 'loadingApp'],
        computed: {
            ...mapState(['VUE_ENV']),
            groupByDate() {
                return this.groupBy(this.data.data, 'created_at');
            },
        },
        methods: {
            groupBy(array, key) {
                const result = {};
                array.forEach(item => {
                    let date = moment(item[key]).format('ll');
                    if (!result[date]) {
                        result[date] = [];
                    }
                    result[date].push(item);
                });
                return result;
            },
        },
    };
</script>
